import { render, staticRenderFns } from "./StateBadgeComponent.vue?vue&type=template&id=2ae867a6&scoped=true"
import script from "./StateBadgeComponent.vue?vue&type=script&lang=ts"
export * from "./StateBadgeComponent.vue?vue&type=script&lang=ts"
import style0 from "./StateBadgeComponent.vue?vue&type=style&index=0&id=2ae867a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae867a6",
  null
  
)

export default component.exports